import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { NdaRedFlagsDetector } from "@/components/NdaRedFlagsDetector";

export const Route = createFileRoute("/nda-scanner")({
  head: () => ({
    meta: [
      { title: "NDA Red Flags Detector — Scan Any NDA in Seconds | legaldecoder" },
      {
        name: "description",
        content:
          "Free NDA scanner: paste any non-disclosure agreement to see a risk score, predatory clauses, and exact wording to push back. Friendly, plain-English NDA review.",
      },
      { property: "og:title", content: "NDA Red Flags Detector — legaldecoder" },
      {
        property: "og:description",
        content:
          "Spot one-sided NDA clauses, hidden non-competes, and unfair penalties. Get a risk score plus a copy-paste negotiation script.",
      },
      { property: "og:url", content: "https://legaldecoder.io/nda-scanner" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://legaldecoder.io/nda-scanner" }],
  }),
  component: NdaScannerPage,
});

function NdaScannerPage() {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Header />
      <main className="flex-1">
        <NdaRedFlagsDetector />
      </main>
      <Footer />
    </div>
  );
}
